import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class ProductUrgency extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Updates urgency visibility when the selected variant changes.
   * @param {CustomEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newUrgency = html.querySelector('product-urgency');
        if (!newUrgency) return;

        morph(this, newUrgency, { childrenOnly: true });
        this.hidden = newUrgency.hasAttribute('hidden');
        this.classList.toggle('product-urgency--hidden', newUrgency.classList.contains('product-urgency--hidden'));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-urgency] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-urgency')) {
  customElements.define('product-urgency', ProductUrgency);
}
